import React from 'react';
import { NavLink } from 'react-router-dom';
import * as Feather from 'react-feather';
import NavBadge from './NavBadge';

const NavSingleItem = ({ item, count, branding, shadeColor, location }) => {
  const Icon = item.icon && Feather[item.icon] ? Feather[item.icon] : null;

  const [hoverActive, setHoverActive] = React.useState(false);

  if (item.external) {
    const rel = item.target && item.target === '_blank' ? 'noopener noreferrer' : null;

    return (
      <li
        className="nav-item nav-item-withCounter"
        onMouseEnter={() => setHoverActive(true)}
        onMouseLeave={() => setHoverActive(false)}
      >
        <a href={item.url} target={item.target} rel={rel}>
          {item.icon && Icon && <Icon className="side-nav-icon" />}
          <span className="nav-item-label">{item.name}</span>
          <span className="nav-item-count">{count}</span>
          {item.badge && <NavBadge color={item.badge.variant} text={item.badge.text} />}
        </a>
      </li>
    );
  } else {
    // Force relative URLs to start with a slash
    const url = item.url.charAt(0) === '/' ? item.url : `/${item.url}`;

    let isActive = false;
    if (location === item.url) {
      isActive = true;
    }

    let bgColor2 = '#0b1628';

    let bgColor = '#ff6a00';

    if (branding.sidebarPrimaryColor) {
      bgColor = branding.sidebarPrimaryColor;
    }

    return (
      <li className="nav-item nav-item-withCounter">
        <NavLink
          to={url}
          style={{
            color: branding.sidebarTextColor,
            background: (isActive || hoverActive) ? shadeColor(bgColor, 20) : bgColor,
          }}
          activeClassName="active"
          onMouseEnter={() => setHoverActive(true)}
          onMouseLeave={() => setHoverActive(false)}
        >
          {item.icon && Icon && <Icon className="side-nav-icon" />}
          <span className="nav-item-label">{item.name}</span>
          {item.badge && <NavBadge color={item.badge.variant} text={item.badge.text} />}
        </NavLink>
        <div className="nav-item-counter">{count}</div>
      </li>
    );
  }
};

export default NavSingleItem;
